import axios from 'api';
import { getCurrentApiUrl } from 'app/helpers';

require('dotenv').config();

export const GET_DEPARTMENTS = '[CONSOLE] GET DEPARTMENTS';
export const GET_DEPARTMENTS_FOR_A_SPECIFIC_BRAND =
  '[CONSOLE] GET DEPARTMENTS FOR A SPECIFIC BRAND';

export function getDepartments() {
  const request = axios.get(`${getCurrentApiUrl()}/departments`);

  return dispatch =>
    request
      .then(response => {
        dispatch({
          type: GET_DEPARTMENTS,
          payload: response.data
        });
      })
      .catch(err => err);
}

export function getDepartmentsForSpecificBrand(id) {
  const request = axios.get(`${getCurrentApiUrl()}/departments?brand=${id}`);

  return dispatch =>
    request
      .then(response => {
        dispatch({
          type: GET_DEPARTMENTS_FOR_A_SPECIFIC_BRAND,
          payload: response.data
        });
      })
      .catch(err => err);
}
